<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("sales_force_opportunity") }}</h4>
                    
                    <button
                      v-if="permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="downloadData()"
                    >
                       <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                  </div>
  
                  <div class="card-body">
                    <vue-good-table
                      title="list-sales-force-rate"
                      ref="list-sales-force-rate"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns"
                     
                    >
  
                        <template slot="column-filter" slot-scope="{ column }">
                      <span v-if="column.filterOptions.customFilter">
                        <span v-if="column.field =='effective_from'">
                          <date-range-picker style="width:100%" @update="fromDatesChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="fromDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a @click="clearfromDatesChange()" class="float-end" style="margin-right: 5px;color:red;">Clear Calendar</a> <span v-if="header.in_selection"> - in selection</span>
                              <br>
                            </div>
                          </date-range-picker>
                        </span>
                      </span>
                        </template>
                        <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                              <a
                                href="#"
                                v-if="permision_role.method_read"
                                title="Detail"
                                @click.prevent="
                                  detailData(props.index, props.row)
                                "
                              >
                                <i class="mdi mdi-eye" style="font-size:16px"></i>
                              </a>
  
                        </span>
                        <span v-else-if="props.column.field == 'effective_from'">
                          {{props.row.effective_from}} - {{props.row.effective_to}}
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                            <span v-if="props.row.status == 'deactive'" class="badge bg-secondary text-uppercase"><h5>{{props.row.status}}</h5></span>
                            <span v-else-if="props.row.status == 'active'" class="badge bg-info text-uppercase"><h5>{{props.row.status}}</h5></span>
                            <span v-else-if="props.row.status == 'sync'" class="badge bg-warning text-uppercase"><h5>{{props.row.status}}</h5></span>
                            <span v-else class="badge bg-warning"><h5>{{props.row.status}}</h5></span>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                        </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
<script>
    import navbarComponent from "@/components/_partials/_navbar";
    import footerComponent from "@/components/_partials/_footer";
    import DateRangePicker from 'vue2-daterange-picker';
  
    export default {
        name: "SalesForceOpportunityBillingHeaderIndex",
        components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
            DateRangePicker,
        },
        data() {
        return {
            opens:"center",
            locale:{
                format:"yyyy-mm-dd",
            
            },
            fromDates: {
                startDate: null,
                endDate: null
            },
            firstDates:{
                startDate: null,
                endDate: null
            },
            highlighted:{

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role:[],
            langs: ["id", "en"],
            detailUser: [],
            rate_header_sf_id:[],
            detailDivisi: [],
            totalRecords: 0,
            transactionFromDate:"",
            firstBilingDate:"",
            transactionToDate:"",
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
            columns: [
                {
                    label: this.$t("idRateSalesForce"),
                    field: "rate_header_sf_id",
                    width: "100px",
                    thClass: 'text-center',
                    filterOptions: {
                    enabled: true, // enable filter for this column
                    customFilter: false,
                    placeholder: this.$t("idRateSalesForce"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("opportunity_id"),
                    field: "opportunity_id",
                    width: "150px",
                    thClass: 'text-center',
                    filterOptions: {
                    enabled: true, // enable filter for this column
                    customFilter: false,
                    placeholder: this.$t("opportunity_id"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("contract_no"),
                    field: "agreement_no",
                    width: "170px",
                    thClass: 'text-center',
                    filterOptions: {
                    enabled: true, // enable filter for this column
                    customFilter: false,
                    placeholder: this.$t("contract_no"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("warehouseId_txt"),
                    field: "warehouse_code",
                    width: "120px",
                    thClass: 'text-center',
                    filterOptions: {
                    enabled: true, // enable filter for this column
                    customFilter: false,
                    placeholder: this.$t("warehouseId_txt"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("customerSAPCode"),
                    field: "customer_code",
                    width: "170px",
                    thClass: 'text-center',
                    filterOptions: {
                    enabled: true, // enable filter for this column
                    customFilter: false,
                    placeholder: this.$t("customerSAPCode"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
        
                {
                    label: this.$t("effectiveDate_txt"),
                    field: "effective_from",
                    thClass: 'text-center',
                    width: "180px",
                    filterOptions: {
                    enabled: true, // enable filter for this column
                    customFilter: true,
                    placeholder: this.$t("effectiveDate_txt"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                
                {
                    label: this.$t("statusTxt"),
                    field: "status",
                    width: "150px",
                    thClass: 'text-center',
                    filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("status_filter_txt"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: ['active','deactive','sync'], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                        enabled: false, 
                    },
                },
            ],
            rows: [],
            rowsSelection:[],
        };
        },
        watch: {},
        methods: {

            toCurrency (value) {
                if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'IDR'
                });
                return formatter.format(value);
            },

            fromDatesChange(){

                if(this.fromDates.startDate && this.fromDates.endDate){
                    this.transactionFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
                    this.transactionToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
                    this.loadItems()
                }

            },

            clearfromDatesChange(){
                this.fromDates={
                    startDate: null,
                    endDate: null
                };
                this.transactionFromDate = ""
                this.transactionToDate = ""
                this.loadItems()
            },

            selectionChanged(ev) {
                this.rowsSelection = [];
                this.rate_header_sf_id   = [];
                this.rowsSelection = ev.selectedRows;
        
                this.rowsSelection.forEach((item) => {
                this.rate_header_sf_id.push(item.rate_header_sf_id);
        
                });
        
            },
    
            downloadData() {
                const baseURI = this.$settings.endPointBilling + "dashboard/sales-force/opportunity-billing/header";
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name = "download_" + CurrentDate + ".xlsx";
        
                let transactionFromDate = this.transactionFromDate
                let transactionToDate   = this.transactionToDate

                return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&rate_header_sf_id=${this.serverParams.columnFilters.rate_header_sf_id}&opportunity_id=${this.serverParams.columnFilters.opportunity_id}&agreement_no=${this.serverParams.columnFilters.agreement_no}&warehouse_code=${this.serverParams.columnFilters.warehouse_code}&customer_code=${this.serverParams.columnFilters.customer_code}&effective_from=${transactionFromDate}&effective_to=${transactionToDate}&status=${this.serverParams.columnFilters.status}&download=download`,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
            },
    
            detailData(index, row) {
                var params = this.$onRandom(row.rate_header_sf_id);
                window.location.href = "/sales_force/opportunity_billing/header/detail/" + params;
            },
    
            logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
            },

            // load items is what brings back the rows from server
            loadItems() {
                const baseURI = this.$settings.endPointBilling + "dashboard/sales-force/opportunity-billing/header";
                this.isLoading = true;
        
                let transactionFromDate = this.transactionFromDate
                let transactionToDate   = this.transactionToDate

                return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&rate_header_sf_id=${this.serverParams.columnFilters.rate_header_sf_id}&opportunity_id=${this.serverParams.columnFilters.opportunity_id}&agreement_no=${this.serverParams.columnFilters.agreement_no}&warehouse_code=${this.serverParams.columnFilters.warehouse_code}&customer_code=${this.serverParams.columnFilters.customer_code}&effective_from=${transactionFromDate}&effective_to=${transactionToDate}&status=${this.serverParams.columnFilters.status}`,
                    { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                        this.loading();
                        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

                    });
            },
        
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
                this.loadItems();
            },
        
            onColumnFilter(params) {
                this.updateParams(params);
            },
    
            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
            },
    
            onSortChange(params) {
                this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
                });
            },
    
            onPerPageChange(params) {
                this.updateParams({ per_page: params.currentPerPage });
            },
    
            resultError(data) {
                var count = Object.keys(data).length;
                for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
                }
            },
    
            success(kata) {
                const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                });
                Toast.fire({
                icon: "success",
                title: kata,
                });
            },
    
            error(kata) {
                const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                });
                Toast.fire({
                icon: "error",
                title: kata,
                });
            },
    
            fade(sType) {
                this.isLoading = sType;
            },
        
            loading() {
                this.fade(true);
                setTimeout(() => {
                this.isLoading = false;
                }, 1000); // hide the message after 3 seconds
            },
        
            fetchIt() {
                const userDatas     = this.$getUserInfo();
                this.detailUser     = userDatas.sub;
                // this.permision_role = userDatas.sub.permision_role;
                let rolePermision = [];
                userDatas.sub.permision_role.forEach(function(permision){
                if(permision.permission.controller == 'SalesForceBillingController'){
                    rolePermision = permision;
                }
                });
        
                if(!rolePermision.method_read){
                this.$router.push("/authorized-error");
                }
                this.permision_role = rolePermision;
        
            },


    
        },
        events: {},
        created: function () {},
        mounted() {
            this.fetchIt();
            this.loading();
        },
    };

</script>
<style scoped>
  .blur-content{
    filter: blur(5px); 
  }
  
</style>